import { ofType, combineEpics } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { RDX_APP_PRE_LOGON, RDX_APP_LOGON, RDX_APP_LOGOUT, RDX_APP_KEEP_ALIVE, RDX_APP_SESSIONTIMEOUT_RESET, RDX_APP_GEN_DSP_AMTOKEN } from '../redux/appAction';

import chnlService from '../api/chnl/chnlService';
import { RDX_SESSION_INIT, updateSession } from '../redux/sessionAction';
import store from '../app/store';
import ObjectHelper from 'approot/common/lib/ObjectHelper';
import { navigate } from '../redux/navAction';
import legacyClientConsentConfig from './../common/config/legacyClientConsentConfig';
import { callDspAmToken } from './../api/apiService';
import { valid } from '../api';
import { setCookie, getCookie } from 'approot/common/lib/CommonUtil';
import { addNotify } from '../redux/notifyAction';
import commonConfig from '../common/config/commonConfig';
import { confirmationPageEsgTmsTrackView } from 'approot/util/taggingUtils';
import { isDspV3Enabled, authenticateDsp } from '../common/auth/dsp';

const constructLogonRequest = (logonState) => {
	return {
		encryptedState: logonState,
		state: ''
	};
};

const preLogon = (action$) => action$.pipe(
	ofType(RDX_APP_PRE_LOGON),
	mergeMap(
		() =>
			callDspAmToken(legacyClientConsentConfig).pipe(
				map((response) => {
					if (valid(response)) {
						return navigate('lccHome');
					}
					return ({ type: 'rdx/Done' });
				}))
	)
);

const appEpic = (action$, state$) => action$.pipe(
	ofType(RDX_APP_LOGON),
	mergeMap(
		// @@WP-REACT: customize LOGON step
		// ...
		() => chnlService.gatewayLogon(constructLogonRequest(state$.value.app.logonState)).pipe(
			map(
				logonResponse => {
					console.log('++++Test: logonResponse = ', logonResponse);
					if (logonResponse.status === '403') {
						return addNotify({ status: 8, code: 'no_premission', hideCode: true });
					} else {
						store.dispatch(updateSession({ staffName: logonResponse.response.staffInfo.name, currentDate: logonResponse.response.logonTime }));
						return { type: RDX_SESSION_INIT };
					}
				}
			)
		)
	)
);

const logOffEpic = (action$) => action$.pipe(
	ofType(RDX_APP_LOGOUT),
	mergeMap(
		// @@WP-REACT: customize LOGOUT step
		// ...
		() => chnlService.gatewayLogoff().pipe(
			map(
				() => {
					return ({ type: 'rdx/Done' });
				}
			)
		)
	)
);

const keepAlive = (action$) => action$.pipe(
	ofType(RDX_APP_KEEP_ALIVE),
	mergeMap(
		// @@WP-REACT: customize keepalive step
		// ...
		() => chnlService.keepAlive().pipe(
			map(
				() => {
					return ({ type: RDX_APP_SESSIONTIMEOUT_RESET });
				}
			)
		)
	)
);
const getDspAMToken = (action$) => action$.pipe(
	ofType(RDX_APP_GEN_DSP_AMTOKEN),
	mergeMap((action) => callDspAmToken(legacyClientConsentConfig).pipe(
		map(res => {
			console.log('dsp AM token: response = ', res);
			const response = res.response;
			if (valid(res) && !ObjectHelper.isNullOrEmpty(response)) {
				const tokenId = response.tokenId;
				console.log('check AMToken', tokenId);
				setCookie('AMToken', tokenId, 10);
			}
			if (action.isNavigate) {
				const { session } = store.getState();
				const questionnaireType = session.questionnaireType;
				if (!ObjectHelper.isNullOrEmpty(questionnaireType) && questionnaireType === 'CCTPR') {
					console.log('questionnaireType', questionnaireType);
					return navigate('lccHome');
				}
				confirmationPageEsgTmsTrackView();
				return navigate('esgHome');
			}
			return ({ type: 'rdx/Done' });
		}))
	)
);

const constructHeaders = () => {
	//const { session } = store.getState();
	//console.log('session is ', session);
	// @@WP-REACT: You may publish the header value from state.session or any data in state
	// ...
	let cookieValue='';
	let extractedValue='en_US';
	try{
		cookieValue=getCookie('HSBC_CLIENT_COOKIE');
		if(cookieValue){
			extractedValue = cookieValue.split('%3D')[1];
			console.log('x-hsbc-locale'+extractedValue);
		}else{
			console.log('No cookie found or cookie value is empty.');
		}
	} catch (error) {
		console.error('HSBC_CLIENT_COOKIE error occurred:', error);
	}
	const header = {
		'Content-Type': 'application/json',
		'x-hsbc-channel-id': 'OHI',
		'x-hsbc-chnl-countryCode': 'HK',
		'x-hsbc-chnl-group-member': 'HBAP',
		'x-hsbc-lob': 'PFS',
		'x-hsbc-locale': extractedValue,
		'Token_type': 'SESSION_TOKEN',
		'x-hsbc-gbgf': 'CDM'
	};
	//if (msgId === 'fetchQuestionnairesResult_wealth' || msgId === 'responses_wealth') {
	//header['X-WEALTH-CUSTOMER-NUMBER'] = session.custID;
	//header['X-HSBC-EMPLOYEE-ID'] = '29000101';
	//header['X-HSBC-CUSTOMER-NUMBER'] = 'IG190148';
	//}

	//if (msgId === 'retrieveCustomerInfoByCustomerId') {
	//header['X-HSBC-Wealth-Customer-Number'] = urlParam.customerId;
	//}

	return header;
};

const removeSAAS_TOKEN_ID_fromUrl = (session) => {
	let [head, tail] = window.location.href.split( '?' );
	//handle includ locale link
	//const heads = head.split('/');
	//head = heads[0] + '/' + heads[1] + '/' + heads[2] + '/' + heads[3] + '/' + heads[4] + '/' + heads[5] + '/' + heads[6];
	//head = heads[0] + '/' + heads[1] + '/' + heads[2] + '/' + heads[3] + '/' + heads[4] + '/' + heads[5];
	console.log('the head split done+', head);
	// if(heads[7] === 'en-us' || heads[7] === 'zh-cn' || heads[7] === 'zh-hk') {
	// 	head += '/' + heads[8];
	// } else {
	// 	head += '/' + heads[7];
	// }
	if(ObjectHelper.isNullOrEmpty(tail)) { //need to pass url params
		if(session !== undefined && session !== null) {
			head += '?model='+session.model+'&locale='+session.locale+'&backUrl='+session.backUrl;
		}
		console.log('the head add the session', head);
		return head;
	}
	else{
		console.log('the head no tail', head);
		return head + '?' + tail.split( '&' ).filter( p => !p.startsWith( 'SAAS_TOKEN_ID=' ) ).join( '&' );
	}
};

export const dspAuthentication = (session) => {
	if (isDspV3Enabled()) {
		return authenticateDsp(undefined, session || store.getState().session);
	}
	const backUrl = removeSAAS_TOKEN_ID_fromUrl(session);
	//define utils function
	const postSecurityForm = (data) => {
		let finalDspWebAuthServletUrl = process.env.REACT_APP_DSP_WEBAUTHSERVLET_URL;
		const formHtml = `<form name="navForm" id="navForm" action="${finalDspWebAuthServletUrl}" method="post" style="display:none">
				<input name="commtoken" value="${data.issued_token}" type="text"></input>
				<input id="submitSecurity" type="submit" value="submit"></input>
			</form>`;
		document.body.innerHTML = formHtml;
		document.navForm.submit();
	};
	// retrieve AnonymousToken
	const dspAnonymousCommsTokenUrl= process.env.REACT_APP_DSP_ANONYMOUSCOMMSTOKEN_URL;
	const bodyJson = {
		'input_token_state': {
			'token_type': 'REQUESTBODY',
			'targetUrl': backUrl,
			'targetCamLevel': '30',
			'functionName': 'IC2ICLAUNCH',
			'cancelUrl': ''
		},
		'output_token_state': {
			'token_type': 'ANONYMOUSJWT'
		}
	};
	return fetch(dspAnonymousCommsTokenUrl, {
		method: 'POST',
		headers: {...commonConfig.dspAnonymousJWTTokenHeaders},
		body: JSON.stringify(bodyJson)
	}).then((response) => {
		return response.json();
	}).then((data) => {
		postSecurityForm(data);
		return new Promise((resolve) => { 
			resolve('Launch DSP logon.'); 
		});
	});
};

export const retrieveBearerTokenAndPutToSessionStorage = (session) => {
	const resolveDes = 'DSP_SESSION_IN_COOKIE';
	const headers = constructHeaders();
	if (isDspV3Enabled()) {
		return authenticateDsp(headers, session || store.getState().session);
	}
	const loginUrl = process.env.REACT_APP_LOGINURL + 'questionnaires/72';
	return fetch(loginUrl, {
		headers,
		method:'GET',
		credentials: 'include',
		withCredentials: true
	}).then((response) => {
		const status = response.status;
		if (status === 401 || status === 403) { // 403: When the resource is forbidden
			return dspAuthentication();
		} else if(status === 500) {
			return new Promise((resolve) => { 
				resolve('call tp logon api failed'); 
			});
		} else {
			return resolveDes;
		}
	});
};

export default combineEpics(preLogon, appEpic, logOffEpic, keepAlive, getDspAMToken);
